import { useSyncExternalStore } from 'react';

/**
 * Граница мобильной раскладки. Та же цифра стоит в @media всех CSS-файлов
 * (max-width: 767px): JS и стили обязаны переключаться одновременно.
 */
const MOBILE_QUERY = '(max-width: 767px)';

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia(MOBILE_QUERY);
  query.addEventListener('change', onChange);

  return () => query.removeEventListener('change', onChange);
};

const getSnapshot = () => window.matchMedia(MOBILE_QUERY).matches;

/**
 * true на узком экране (телефон). matchMedia, а не размер visualViewport:
 * pinch-zoom на ноутбуке не должен переключать раскладку на мобильную.
 */
export function useMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
